import { render, staticRenderFns } from "./Igmp.vue?vue&type=template&id=04624618&"
import script from "./Igmp.vue?vue&type=script&lang=js&"
export * from "./Igmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports